export const fetch = (state, page = 1) => {
  if (page === 1) {
    return { ...state, byId: {}, ids: [], isFetching: true };
  }

  return { ...state, isFetching: true };
};

export const fetched = (state, entities, ids, metadata = {}) => ({
  ...state,
  metadata,
  isFetching: false,
  byId: { ...state.byId, ...entities },
  // Ensure values are unique
  ids: Array.from(new Set([...state.ids, ...ids])),
});

export const create = state => ({
  ...state,
  isCreating: true,
  errors: undefined,
});

export const created = (state, object, id, { prepend } = {}) => ({
  ...state,
  isCreating: false,
  byId: { ...state.byId, [id]: object },
  ids: prepend ? [id, ...state.ids] : [...state.ids, id],
});

export const createInvalid = (state, errors) => ({
  ...state,
  errors,
});

export const update = (state, id) => ({
  ...state,
  byId: { ...state.byId, [id]: { ...state.byId[id], isUpdating: true } },
});

export const updated = (state, object, id) => ({
  ...state,
  byId: {
    ...state.byId,
    [id]: {
      ...state.byId[id],
      ...object,
      isUpdating: false,
    },
  },
});

export const destroy = (state, id) => ({
  ...state,
  byId: { ...state.byId, [id]: { ...state.byId[id], isDestroying: true } },
});

export const destroyed = (state, id) => ({
  ...state,
  byId: { ...state.byId, [id]: { ...state.byId[id], isDestroying: false } },
  ids: state.ids.filter(_id => _id !== id),
});



// WEBPACK FOOTER //
// ./src/helpers/cruducer.js